import { useNav } from "@/context/NavContext";
import NotFound from "@/pages/NotFound";

export default function NavGuard({ navKey, children }) {
  const { items, loading } = useNav();

  if (loading) {
    return <div className="min-h-screen bg-[#050505]" />;
  }

  const item = items.find((i) => i.key === navKey);
  if (item && item.visible === false) {
    return <NotFound />;
  }

  return children;
}
